import React from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import LoadingSetData from "../../TESTPage/LoadingSetData";
import { useEffect } from "react";
import { useState } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { GetCookieData, GetCookieToken } from "../../Cookie/GetCookie";
import ModalBorrowTable from "./ModalBorrowTable";
import BorrowedTable from "../BorrowedTable";

const TableBorrowPage = () => {

  const user = GetCookieData("userData")

  const baseURL = process.env.REACT_APP_API_CORS
  const token = GetCookieToken("userToken")

  const [currentPage, setCurrentPage] = useState(1)
  const [totalPage, setTotalPage] = useState()
  const [borrowData, setBorrowData] = React.useState([]);
  const [openBorrow, setOpenBorrow] = React.useState(false);

  const [modalState, setModalState] = useState("")

  const toggleModal = () => {
    setOpenBorrow(!openBorrow);
  };

  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    setTimeout(() => {
      setLoading(true);
    }, 1000);
  }, []);

  const getBorrowDataTable = (page) => {

    const pageParam = page || 1
    const user_id = user.user_id

    axios.get(baseURL+`/api/borrow/equipment/datatable?page=${pageParam}&size=10&order[0]=created_date&order[1]=DESC&filter[users_id_borrow][0]=${user_id}`,{
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then((res) => {
      setBorrowData(res.data.result)
      setCurrentPage(res.data.info.currentPage)
      setTotalPage(res.data.info.totalPage)
    }).catch((err) => {
      console.error(err);
    })
  }

  React.useEffect(() => {
    getBorrowDataTable(currentPage,user.user_id)
  },[])

  const getEequipmentDatatable = () => {
    axios.get(baseURL+`/api/equipment/datatable?page=1&size=10&order[0]=created_date&order[1]=DESC`,{
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then((res) => {
    }).catch((err) => {
      console.error(err);
    })
  }

  useEffect(() => {
    getEequipmentDatatable();
  },[])

  const convetToSplitDateTime = (dateTime) => {
    let OBJdateTime = {
      date: dateTime.split("T")[0],
      time: dateTime.split("T")[1].split(".")[0],
    }
    return OBJdateTime
  }

  const [deleteBorrow, setDeleteBorrow] = useState(false);
  const handleToggleModalDeleteBorrow = () => {
    setDeleteBorrow(!deleteBorrow);
  };
  const deleteRowBorrow = (id) => {
    setBorrowData((prev) => prev.filter((item) => item.id !== id));
    axios
      .delete(baseURL + `/api/borrow/equipment/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
      })
      .catch((err) => {
        console.error(err);
      });
    handleToggleModalDeleteBorrow()
  };
  
  return (
    <div className="page-content">
      {!loading ? (
        <LoadingSetData />
      ) : (
        <FadeIn>
          <Container fluid>
            <Breadcrumb
              title="ทรัพยากรออนไลน์"
              breadcrumbItem="รายการยืมครุภัณฑ์"
              isBack={true}
              path="/resorcemanagement"
            />
                <BorrowedTable
                  currentPage={currentPage}
                  totalPage={totalPage}
                  deleteBorrow={deleteBorrow}
                  deleteRowBorrow={deleteRowBorrow}
                  borrowData={borrowData}
                  getBorrowDataTable={getBorrowDataTable}
                  modalState={modalState}
                  setModalState={setModalState}
                  openBorrow={openBorrow}
                  toggleModal={toggleModal}
                  fromIndex={false}
                  handleToggleModalDeleteBorrow={handleToggleModalDeleteBorrow}
                />
          </Container>
          
        </FadeIn>
        
      )}
    </div>
  );
};

export default TableBorrowPage;
